<template>
  <section class="how-booking-work">
    <BaseTitleSection :title="title" class="how-booking-work__title" />
    <div class="how-booking-work">
      <div class="how-booking-work__main">
        <div class="w-full lg:w-2/3">
          <div>
            <BasePlayerBasic
              :src="item.main.video"
              :cover="item.main.video_cover"
              classes=""
              name="becomeTutor"
            />
          </div>
        </div>
        <div class="w-full lg:w-1/3">
          <p class="text__headline-4-xs--bold lg:text__headline-4-md--bold mt-4 lg:mt-7">
            {{ item.main.header }}
          </p>
          <p class="text__caption-xs--regular lg:text__body-2-md--regular mt-4 text-body-2">
            {{ item.main.content }}
          </p>
          <CommonContinueRegistration btn-class="mt-5 lg:mt-12 w-full">
            <template #else>
              <BaseButton
                :label="$t('actions.signup_teach')"
                light
                shadow
                class="mt-5 lg:mt-12 w-full lg:w-[267px]"
                @click="$emit('signup')"
              />
            </template>
          </CommonContinueRegistration>
        </div>
      </div>
      <div class="how-booking-work__list">
        <div class="w-[1000px] lg:w-auto flex flex-row space-x-3 flex-wrap lg:flex-nowrap">
          <div v-for="(el,key) in item.list" :key="el.title" class="item">
            <div class="text-center">
              <div
                class="square-number"
                :class="el.color"
              >
                {{ key+1 }}
              </div>
            </div>
            <p class="item__title">
              {{ el.title }}
            </p>
            <p class="item__subtitle">
              {{ el.subtitle }}
            </p>
            <div class="w-full rounded-2xl mt-4">
              <BaseImg
                class="w-full"
                :src="el.img"
                :alt="el.title"
                :sizes="{lg:['357',192 ], xs:['269','142']}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import { mapGetters } from 'vuex'
import BasePlayerBasic from '@design-system/base/player/player-basic.vue'
import CommonContinueRegistration from '~/components/common/continue-registration.vue'
export default {
  name: 'StartTeachingHowBecomeTutor',
  components: { CommonContinueRegistration, BasePlayerBasic },
  data () {
    return {
      title: 'Become an online tutor in Ostado'
    }
  },
  computed: {
    ...mapGetters('local', ['getIntroduction']),
    item () {
      return {
        main: { ...this.getIntroduction },
        list: [
          {
            color: 'bg-orange',
            title: 'Fill out the forms',
            subtitle: 'complete our registration forms and Take the first step towards an exciting journey as a tutor!',
            img: '/front-img/start-teaching/become-tutor-1.webp'
          },
          {
            color: 'bg-pink',
            title: 'Verification',
            subtitle: 'This step involves evaluations. Once approved by our expert team, tutors can start teaching!',
            img: '/front-img/start-teaching/become-tutor-2.webp'
          },
          {
            color: 'bg-purple',
            title: 'Start teaching!',
            subtitle: 'Take the last step and start teaching, where you can inspire others with your expertise.',
            img: '/front-img/start-teaching/become-tutor-3.webp'
          }
        ]
      }
    }
  },
  methods: {
    tutorBookBtnClicked () {
      console.log('tutor book btn clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.how-booking-work {
  @apply container text-center;
  &__title {
  @apply mb-8;
  }
  &__main {
    @apply flex flex-col lg:flex-row items-center border border-primary-100 rounded-2xl
    lg:space-x-6 p-4 mb-8 lg:mb-12 text-left;
  }
  &__list {
    @apply relative w-full overflow-x-auto;
    &::-webkit-scrollbar {
      width: 0;  /* Remove scrollbar space */
      background: transparent;  /* Optional: just make scrollbar invisible */
    }
    .item {
      @apply border border-primary-100 rounded-2xl p-4 lg:w-1/3 w-[275px];
      &__title {
        @apply text__headline-4-xs--bold lg:text__headline-4-md--bold mt-4 text-left;
      }
      &__subtitle {
        @apply text__caption-xs--regular lg:text__body-2-md--regular mt-2 text-left;
      }
    }
  }
  .square-number {
    @apply rounded-lg w-10 h-10 lg:w-12 lg:h-12 text-white flex items-center justify-center
    text__headline-4-md--bold lg:text__headline-3-md--bold;
    text-shadow: 3px 2px black;
  }
}
</style>
